// Route `api` cho thực thể `hrStaff` (J-09): JSON của `/v1/staff` (TblStaff, cột an toàn: Id, UserName, FullName, Dept, Position, Group, Branch — không lương / CCCD / số tài khoản)
// → `Staff` của màn. Cột worker CHƯA trả (ghế, ngày vào, backup, phép còn) lấy từ dữ liệu mẫu CÙNG mã đăng nhập; người thật không có bản mẫu thì mặc định trung tính.
// Chưa gắn vào `apiRoutes` của zone Mee (file của B) — xem issue luong-b; SQL 012 chưa chạy thì worker trả 503 và màn giữ dữ liệu mẫu.
import type { ApiRoute, ApiRoutes } from '@hana/data';
import { STAFF } from './fixtures';
import type { Staff } from './types';

type Row = Record<string, unknown>;
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

const SAMPLE = new Map(STAFF.map((s) => [s.id.toUpperCase(), s]));

export function staffFromApi(r: Row): Staff | null {
  const id = str(r.UserName);
  if (!id) return null;
  const sample = SAMPLE.get(id.toUpperCase());
  return {
    seats: [],
    status: 'Đang làm',
    joined: '—',
    backup: '—',
    leaveLeft: 0,
    ...(sample ?? {}),
    id,
    name: str(r.FullName) || sample?.name || id,
    dept: str(r.Dept) || sample?.dept || '',
  };
}

export const staffApiRoute: ApiRoute<Staff> = {
  path: '/api/v1/staff',
  query: (q) => {
    const limit = q.limit && q.limit > 0 ? q.limit : 50;
    return { q: q.q?.trim(), limit, page: Math.floor((q.offset ?? 0) / limit) + 1 };
  },
  parse: (json) => {
    const j = (json ?? {}) as { items?: unknown; hasMore?: boolean };
    const rows = Array.isArray(j.items) ? (j.items as Row[]) : [];
    return { items: rows.map(staffFromApi).filter((s): s is Staff => s !== null), hasMore: j.hasMore === true };
  },
};

/** B gom vào `apiRoutes` của zone Mee. */
export const hrApiRoutes: ApiRoutes = { hrStaff: staffApiRoute };
